import React from 'react';
import { ShieldIcon } from 'lucide-react';
export function Header() {
  return <header className="bg-slate-900/80 backdrop-blur-md border-b border-slate-800 py-4 px-5 md:px-8 sticky top-0 z-50" data-id="element-71">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-72">
        <div className="flex items-center gap-2 text-white font-bold text-lg md:text-xl tracking-wide" data-id="element-73">
          <ShieldIcon className="h-6 w-6 text-brand-500" data-id="element-74" />
          <span data-id="element-75">EL CÓDIGO</span>
        </div>
        <a href="#comprar" className="bg-brand-600 hover:bg-brand-500 text-white font-semibold px-4 py-2 md:px-6 md:py-2.5 rounded-lg transition-all duration-300 shadow-[0_0_15px_rgba(13,148,136,0.3)] text-sm md:text-base transform hover:scale-105 active:scale-95" data-id="element-76">
          Quiero el Código
        </a>
      </div>
    </header>;
}